'use client';

import Card, { CardProps } from '@/components/Card';
import Box from '@/components/ui/Box';
import Flex from '@/components/ui/Flex';
import { ColorScheme, useColorScheme } from '@/lib/parsers/common';
import Grid from '../ui/Grid';

export type OverviewCardProps = CardProps & {
  flipAlignment?: boolean;
  colorScheme?: ColorScheme;
};

const OverviewCard = ({ item, colorScheme, ...props }: OverviewCardProps) => {
  const { oppositeScheme } = useColorScheme(colorScheme);
  const { href, ...card } = item;

  return (
    <Card elevation={false} item={card} cx={{ pX: 'margin' }} {...props}>
      <Grid>
        <Grid.Col md={10}>
          <Flex spacing="md">
            <Card.Title as="span" variant="h3" uppercase />
            <Card.Description />
            {href && (
              <Box cx={{ width: '50' }}>
                <Card.Cta
                  href={href}
                  color={oppositeScheme}
                  variant="filled"
                  size="large"
                  fullWidth
                />
              </Box>
            )}
          </Flex>
        </Grid.Col>
      </Grid>
    </Card>
  );
};

export default OverviewCard;
